import { ExternalCalendarEvent } from '@griply/types';

export type ExternalCalendarEventKeyInput = Pick<
  ExternalCalendarEvent,
  'id' | 'connectionId' | 'calendarId'
>;

// A provider event id is unique per calendar, not per user: one event on two connected calendars repeats it.
export const getExternalCalendarEventKey = ({
  id,
  connectionId,
  calendarId,
}: ExternalCalendarEventKeyInput): string =>
  `${connectionId ?? ''}:${calendarId ?? ''}:${id}`;
